<template>
    <div style="color: blue">
        <div class="news_outstyle" style="background-color: white; ">

            <van-field
                    placeholder="京选快报"
                    readonly
                    style="padding: 0px; background-color: rgba(0,0,0,0)"
            >
                <div slot="label">
                    <div style="font-size: 15px; line-height: 44px; text-align: center; color: #EE0A24;">
                        京选快报
                    </div>
                </div>
                <div slot="input">
                    <van-swipe :autoplay="autoPlay"
                               :duration="1000"
                               :show-indicators="false"
                               vertical
                               :touchable="false"
                               style="height: 44px"
                    >
                        <div v-for="(item, index) in datas" :key="index">
                            <van-swipe-item v-if="$common.isShowComponent(item)">
                                <div @click="clickItem(item.props)">
                                    <van-cell :title="item.props.text" :icon="item.props.icon"
                                              style="font-size: 14px; padding-left: 0px; padding-right: 10px; background-color: rgba(0,0,0,0)">
                                        <div slot="icon" style="padding: 3px 3px 3px 0px;">
                                            <van-icon :name="item.props.icon" size="16"></van-icon>
                                        </div>
                                        <div slot="title" class="msg_div">
                                            {{item.props.text}}
                                        </div>
                                    </van-cell>
                                </div>

                            </van-swipe-item>
                        </div>
                    </van-swipe>
                </div>
            </van-field>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Wp_news",
        props: {
            datas: {type: Array},// [{component: "", id: "", props:{}}]
            autoPlay: {type: Number, default: 5000}
        },

        methods: {
            clickItem(item) {
                this.$emit("clickItem", item)
            }
        }
    }
</script>

<style scoped>
    .news_outstyle {
        border-radius: 5px;
        box-shadow: 1px 1px 5px #999999;
    }

    .msg_div {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
    }

</style>